import React, { useMemo } from "react";
import { Modal, Card } from "antd";
import styled from "@emotion/styled";
import COLORS from "common/Colors";
import UITabs from "atoms/UITabs";
import moment from "moment";
import Wrapper, { CardImage } from "./style";
import { useTranslation } from "react-i18next";

const { Meta } = Card;

const StyledModal = styled(Modal)`
  border-radius: 10px;

  p {
    font-size: 16px;
    color: ${COLORS.TEXT.PRIMARY};
    font-weight: 600;
  }

  .ant-modal-content {
    border-radius: 10px;
  }

  .ant-modal-footer {
    display: none;
  }

  .stylebtn {
    min-width: 130px;
  }
`;

const img =
  "https://tymeplusformbuildtemplate.s3.ap-south-1.amazonaws.com/image+(19).png";

function FormListModal({
  handleChoose,
  templateForm,
  createdForm,
  onCancel,
  open,
}) {
  const { t } = useTranslation();

  const MemoizedCard = useMemo(() => {
    return React.memo(({ item, description = false }) => {
      return (
        <Wrapper>
          <Card
            key={item.id}
            hoverable
            cover={
              <CardImage
                className={`px-4`}
                onClick={() => {
                  handleChoose(item);
                }}
              >
                <img alt="example" src={item?.img ? item?.img : img} />
              </CardImage>
            }
            bordered={true}
            className={`cards`}
          >
            <Meta
              title={item?.title ? item?.title : t("Untitled form")}
              description={`${t("Created on")} ${moment(
                item?.insertedAt
              ).format("DD MMM YYYY")}`}
            />
          </Card>
        </Wrapper>
      );
    });
  }, [handleChoose, t]);

  const CardContainer = ({ data }) => {
    return (
      <Wrapper>
        <div className="card-container">
          {data?.map((item) => (
            <MemoizedCard key={item.id} item={item} />
          ))}
        </div>
      </Wrapper>
    );
  };

  const items = [
    {
      id: 1,
      label: t("Created"),
      component: <CardContainer data={createdForm} />,
    },
    {
      id: 2,
      label: t("Templates"),
      component: <CardContainer data={templateForm} />,
    },
  ];

  return (
    <div>
      <StyledModal
        title=""
        open={open}
        onCancel={onCancel}
        closeIcon={null}
        width={1000}
      >
        <div className="mt-3 text-center">
          <p></p>
          <div>
            <UITabs items={items} />
          </div>
        </div>
      </StyledModal>
    </div>
  );
}

export default FormListModal;
